"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = require("react");

var util_1 = require("../util");

var Value_1 = require("../Value");

var renderProp_1 = tslib_1.__importDefault(require("../util/renderProp"));

var faccToHoc_1 = tslib_1.__importDefault(require("../util/faccToHoc"));

exports.FocusSensor = function (props) {
  var bond = props.bond;
  return Value_1.Value({
    render: function render(_a) {
      var value = _a.value,
          set = _a.set;

      var _b;

      if (bond) {
        if (typeof bond === 'boolean') {
          bond = 'bond';
        }

        return renderProp_1.default(props, (_b = {
          isFocused: value
        }, _b[bond] = {
          onFocus: function onFocus() {
            return set(true);
          },
          onBlur: function onBlur() {
            return set(false);
          }
        }, _b));
      } else {
        var element = renderProp_1.default(props, {
          isFocused: value
        });
        return react_1.cloneElement(element, {
          onFocus: function onFocus() {
            return set(true);
          },
          onBlur: function onBlur() {
            return set(false);
          }
        });
      }
    }
  });
};

var FocusSensorWithBond = function FocusSensorWithBond(props) {
  return util_1.h(exports.FocusSensor, tslib_1.__assign({
    bond: true
  }, props));
};

exports.withFocus = faccToHoc_1.default(FocusSensorWithBond, 'focus');